import './App.scss';
import './design/assets/styles/wfi/splash.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import "primeicons/primeicons.css";
import { QueryClient, QueryClientProvider, useQueries } from '@tanstack/react-query';
import { AuthenticationContextProvider } from 'contexts/authentication.context';
import MainRouter from './routers/Main.router.js';

const queryClient = new QueryClient();

export default function App() {
  return (
      <QueryClientProvider client={queryClient}>
        <AuthenticationContextProvider>
          <MainRouter />
        </AuthenticationContextProvider>
      </QueryClientProvider>
  );
}